module.exports = {};



//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/core-js/library/modules/_iterators.js
// module id = 87
// module chunks = 1